import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from './actions'

export const useMediaSubTypes = () => {

    const {
        refresh,
        initialize,
        types = [],
    } = useSelector((state) => state.mediaSubType);

    const dispatch = useDispatch();

    const setRefreshMediaSubTypes = useCallback(
        (payload) => dispatch(actions.setRefreshMediaSubTypes(payload)),
        [dispatch]
    );

    const setMediaSubTypes = useCallback(
        (payload) => dispatch(actions.setMediaSubTypes(payload)),
        [dispatch]
    );

    return {
        refresh,
        initialize,
        types,
        setRefreshMediaSubTypes,
        setMediaSubTypes
    };
} 